module.exports = __webpack_public_path__ + "img/nav-back.b6ca3917.svg";